// src/components/NavBar.jsx
import React from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";

const NavBar = () => {
  const { user, handleLogout, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const onLogout = () => {
    handleLogout();
  };

  return (
    <nav className="navbar">
      <Link to="/" className="navbar-logo">
        SHASTINO
      </Link>

      {isAuthenticated ? (
        <div className="navbar-links">
          <Link to="/dashboard">Dashboard</Link>
          <Link to="/componentes">Componentes</Link>
          <Link to="/productos">Productos</Link>
          <Link to="/presupuestos">Presupuestos</Link>

          <span className="username">
            Hola, <strong>{user?.username || "Usuario"}</strong>
          </span>

          <button onClick={onLogout} className="logout-button">
            Logout
          </button>
        </div>
      ) : (
        <div className="login-container">
          <button onClick={() => navigate("/")} className="login-button">
            Login
          </button>
        </div>
      )}
    </nav>
  );
};

export default NavBar;